/* eslint-disable */
import * as Types from '../../../models/schema.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterVariablesDTO = Types.Exact<{
  input: Types.PupilCreateInputDTO;
}>;


export type RegisterDTO = { __typename?: 'Mutation', createOnePupil: { __typename?: 'Pupil', id: string } };


export const RegisterDocumentDTO = gql`
    mutation register($input: PupilCreateInput!) {
  createOnePupil(data: $input) {
    id
  }
}
    `;
export type RegisterMutationFnDTO = Apollo.MutationFunction<RegisterDTO, RegisterVariablesDTO>;

/**
 * __useRegister__
 *
 * To run a mutation, you first call `useRegister` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegister` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [register, { data, loading, error }] = useRegister({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegister(baseOptions?: Apollo.MutationHookOptions<RegisterDTO, RegisterVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterDTO, RegisterVariablesDTO>(RegisterDocumentDTO, options);
      }
export type RegisterHookResult = ReturnType<typeof useRegister>;
export type RegisterMutationResultDTO = Apollo.MutationResult<RegisterDTO>;
export type RegisterMutationOptionsDTO = Apollo.BaseMutationOptions<RegisterDTO, RegisterVariablesDTO>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BackgroundJob": [
      "DeleteUserResourceAccessesFromPastSchoolyearsBackgroundJob",
      "DeleteUsersWithoutUserResourceAccessesBackgroundJob",
      "ImportSchoolOnboardingsBackgroundJob",
      "ImportShopItemOrderBundleSheetsBackgroundJob",
      "SyncModuleRegistrationsBackgroundJob"
    ],
    "BingoCampaignAction": [
      "ManualBingoCampaignAction",
      "ManualMeasurementBingoCampaignAction",
      "ModuleRegistrationBingoCampaignAction",
      "PupilCreditsBingoCampaignAction",
      "QuizBingoCampaignAction"
    ],
    "BingoCampaignReward": [
      "GameEnergyBingoCampaignReward",
      "PupilCreditsBingoCampaignReward"
    ],
    "Campaign": [
      "BingoCampaign",
      "VideoCampaign"
    ],
    "SearchItem": [
      "CampaignSearchItem",
      "ChallengeSearchItem",
      "ClassSearchItem",
      "ContentItemSearchItem",
      "DeviceSearchItem",
      "ExerciseSearchItem",
      "ModuleSearchItem",
      "ProjectSearchItem",
      "PupilSearchItem",
      "QuizSearchItem",
      "RegimeSearchItem",
      "RewardSearchItem",
      "SchoolSearchItem",
      "SchoolyearSearchItem",
      "ShopItemSearchItem",
      "UserSearchItem"
    ]
  }
};
      export default result;
    